// Defines which dashboard tabs each USER_ROLE can see. Consumed by App.js
// to filter the tab list and choose a safe default active tab. Keep these
// tab ids in sync with the `id` values in the TABS array in App.js.
const ALL_TABS = [
  'briefing',
  'calendar',
  'todos',
  'loans',
  'loanboard',
  'deadlines',
  'pipeline',
  'goals',
  'projects',
  'wisehire',
  'analytics',
];

// Every role below lists its tabs explicitly. ALL_TABS is the registry of
// tab ids that exist in the app (also used by App.js as a fail-open
// fallback for unrecognised roles), not any one role's list -- it is not
// assigned directly to a role here, so adding a new tab to the registry is
// opt-in per role instead of automatically visible to whichever role used
// to alias it.
const ROLE_TABS = {
  admin: ['briefing', 'calendar', 'todos', 'loans', 'pipeline', 'goals', 'projects', 'analytics'],
  ceo: ['briefing', 'calendar', 'todos', 'loans', 'pipeline', 'goals', 'projects', 'wisehire', 'analytics'],
  loan_officer: ['briefing', 'calendar', 'todos', 'loans', 'pipeline', 'goals', 'projects'],
  processor: ['briefing', 'calendar', 'todos', 'loanboard', 'deadlines', 'pipeline', 'goals'],
  // Both originates and processes loans, so this role gets the processor
  // tab set plus Active Loans. Active Loans scopes itself to the logged-in
  // officer's own loans client-side (see ActiveLoansTab in App.js), while
  // the Loan Board and Pipeline show the whole company.
  loan_officer_processor: ['briefing', 'calendar', 'todos', 'loans', 'loanboard', 'deadlines', 'pipeline', 'goals'],
};

function getVisibleTabs(role) {
  return ROLE_TABS[role] || [];
}

function canAccessTab(role, tabId) {
  return getVisibleTabs(role).includes(tabId);
}

export { ALL_TABS, ROLE_TABS, getVisibleTabs, canAccessTab };
